var makeString = require('./helper/makeString');

module.exports = function strLeft(str, sep) {
  str = makeString(str);
  sep = makeString(sep);
  var pos = !sep ? -1 : str.indexOf(sep);
  return~ pos ? str.slice(0, pos) : str;
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/strLeft.js
// module id = 2288
// module chunks = 0